// import React, {useEffect, useState} from 'react';
// import {ProgressBarSteps, ProgressBarStepLabelMap} from '@/constants';
// import { Text } from '@/ui-kits';

// interface ProgressBarProps {
//   currentStep: ProgressBarSteps;
//   onComplete?: () => void;
//   animationDuration?: number; // ms
// }

// export const ProgressBar: React.FC<ProgressBarProps> = ({
//   currentStep,
//   onComplete,
//   animationDuration = 700
// }) => {
//   const steps = Object.values(ProgressBarSteps).filter(
//     v => typeof v === 'number'
//   ) as ProgressBarSteps[];

//   const totalSteps = steps.length;
//   const [progress, setProgress] = useState(0);
//   const [prevStep, setPrevStep] = useState(currentStep);

//   // Calculate progress dynamically
//   const getProgressForStep = (step: ProgressBarSteps) => {
//     const index = steps.indexOf(step);
//     return (index / (totalSteps - 1)) * 100;
//   };

//   useEffect(() => {
//     // Only update if step actually increased
//     if (currentStep > prevStep) {
//       setPrevStep(currentStep);

//       // Small delay for smooth transition
//       setTimeout(() => {
//         setProgress(getProgressForStep(currentStep));
//       }, 500);

//       // Trigger onComplete when reaching final step
//       if (currentStep === ProgressBarSteps.Complete) {
//         setTimeout(() => {
//           onComplete?.();
//         }, animationDuration);
//       }
//     }
//   }, [currentStep]);

//   const label = ProgressBarStepLabelMap[currentStep];

//   return (
//     <div className="w-full flex flex-col gap-2">
//       <div className="text-center">
//         <Text variant='tiny' className="text-sm text-ui_blue">
//           Please bear with us as the AI categorization process is underway.
//           Thank you for your patience
//         </Text>
//       </div>
//       <span className="flex w-full items-center gap-[1px]">
//         <div className="h-3 border-ui_grey/50 rounded-sm border-2 flex-grow">
//           <div
//             className="h-full bg-gradient-to-br rounded-sm from-ui_blue to-ui_blue_light transition-all ease-out"
//             style={{
//               width: `${progress}%`,
//               transitionDuration: `${animationDuration}ms`,
//             }}
//           />
//         </div>
//         <Text variant='tiny' className="text-sm text-ui_blue -translate-y-[1px]">
//           {Math.round(progress)}%
//         </Text>
//       </span>
//     </div>
//   );
// };

// import React, {useEffect, useRef, useState} from 'react';
// import {ProgressBarSteps, ProgressBarStepLabelMap} from '@/constants';
// import { Text } from '@/ui-kits';

// interface ProgressBarProps {
//   currentStep: ProgressBarSteps;
//   onComplete?: () => void;
//   animationDuration?: number; // ms
// }

// export const ProgressBar: React.FC<ProgressBarProps> = ({
//   currentStep,
//   onComplete,
//   animationDuration = 700
// }) => {
//   const steps = Object.values(ProgressBarSteps).filter(
//     v => typeof v === 'number'
//   ) as ProgressBarSteps[];

//   const totalSteps = steps.length;

//   const [displayStep, setDisplayStep] = useState<ProgressBarSteps>(
//     ProgressBarSteps.NotStarted
//   );
//   const [progress, setProgress] = useState(0);

//   const queueRef = useRef<ProgressBarSteps[]>([]);
//   const isAnimatingRef = useRef(false);
//   const animationTimeoutRef = useRef<NodeJS.Timeout | null>(null);

//   // Calculate progress dynamically
//   const getProgressForStep = (step: ProgressBarSteps) => {
//     const index = steps.indexOf(step);
//     return (index / (totalSteps - 1)) * 100;
//   };

//   const processNextStep = () => {
//     // Don't process if currently animating or queue is empty
//     if (isAnimatingRef.current || queueRef.current.length === 0) {
//       return;
//     }

//     const nextStep = queueRef.current.shift()!;
//     isAnimatingRef.current = true;

//     // Update label immediately
//     setDisplayStep(nextStep);

//     // Small delay so text changes before bar moves
//     setTimeout(() => {
//       setProgress(getProgressForStep(nextStep));
//     }, 100);

//     // Wait for animation to complete before processing next step
//     animationTimeoutRef.current = setTimeout(() => {
//       isAnimatingRef.current = false;

//       // Trigger onComplete callback if we reached the final step
//       if (nextStep === ProgressBarSteps.Complete) {
//         onComplete?.();
//       }

//       // Process next item in queue (if any)
//       if (queueRef.current.length > 0) {
//         processNextStep();
//       }
//     }, animationDuration + 100); // Add 100ms buffer to ensure animation completes
//   };

//   // Enqueue step updates - watch currentStep only
//   useEffect(() => {
//     // Get current display step from state ref
//     setDisplayStep(prev => {
//       if (currentStep > prev) {
//         const nextSteps = steps.filter(s => s > prev && s <= currentStep);

//         // Only add steps that aren't already in the queue
//         const uniqueSteps = nextSteps.filter(s => !queueRef.current.includes(s));

//         if (uniqueSteps.length > 0) {
//           queueRef.current.push(...uniqueSteps);

//           // Start processing if not already animating
//           if (!isAnimatingRef.current) {
//             // Use setTimeout to avoid state update during render
//             setTimeout(() => processNextStep(), 0);
//           }
//         }
//       }
//       return prev;
//     });
//   }, [currentStep]); // Only watch currentStep

//   // Cleanup timeout on unmount
//   useEffect(() => {
//     return () => {
//       if (animationTimeoutRef.current) {
//         clearTimeout(animationTimeoutRef.current);
//       }
//     };
//   }, []);

//   const label = ProgressBarStepLabelMap[displayStep];

//   return (
//     <div className="w-full flex flex-col gap-2">
//       <div className="text-center">
//         <Text variant='tiny' className="text-sm text-ui_blue">
//           Please bear with us as the AI categorization process is underway.
//           Thank you for your patience
//         </Text>
//       </div>
//       <span className="flex w-full items-center gap-[1px]">
//         <div className="h-3 border-ui_grey/50 rounded-sm border-2 flex-grow">
//           <div
//             className="h-full bg-gradient-to-br rounded-sm from-ui_blue to-ui_blue_light transition-all ease-out"
//             style={{
//               width: `${progress}%`,
//               transitionDuration: `${animationDuration}ms`,
//             }}
//           />
//         </div>
//         <Text variant='tiny' className="text-sm text-ui_blue -translate-y-[1px]">
//           {Math.round(progress)}%
//         </Text>
//       </span>
//     </div>
//   );
// };

import React, {useEffect, useRef, useState} from 'react';
import {
  ProgressBarSteps,
  UploadAdditionalFilesProgressBarSteps,
  ProgressBarStepLabelMap,
  UploadAdditionalFilesProgressBarStepLabelMap,
  LoaderBarType,
} from '@/constants';
import {Text} from '@/ui-kits';
import { cn } from '@/utils/common_functions';

type StepType = ProgressBarSteps | UploadAdditionalFilesProgressBarSteps;

interface ProgressBarProps {
  loaderType?: LoaderBarType;
  currentStep: StepType;
  onComplete?: () => void;
  animationDuration?: number;
  message?: string;
  className?: string;
  messageClassName?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  loaderType = LoaderBarType.PatientDashboard,
  currentStep,
  onComplete,
  animationDuration = 700,
  message = 'Please bear with us as the AI categorization process is underway. Thank you for your patience.',
  className = '',
  messageClassName = '',
}) => {
  // Select appropriate enum and label map based on loader type
  const {steps, labelMap} = React.useMemo(() => {
    if (loaderType === LoaderBarType.PatientConsultation) {
      return {
        steps: Object.values(UploadAdditionalFilesProgressBarSteps).filter(v => typeof v === 'number') as UploadAdditionalFilesProgressBarSteps[],
        labelMap: UploadAdditionalFilesProgressBarStepLabelMap,
      };
    }

    return {
      steps: Object.values(ProgressBarSteps).filter(v => typeof v === 'number') as ProgressBarSteps[],
      labelMap: ProgressBarStepLabelMap,
    };
  }, [loaderType]);

  const totalSteps = steps.length;

  const [displayStep, setDisplayStep] = useState<StepType>(steps[0]);
  const [progress, setProgress] = useState(0);

  const queueRef = useRef<StepType[]>([]);
  const isAnimatingRef = useRef(false);
  const animationTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Calculate progress dynamically
  const getProgressForStep = (step: any) => {
    const index = steps.indexOf(step);
    return (index / (totalSteps - 1)) * 100;
  };

  const processNextStep = () => {
    // Don't process if currently animating or queue is empty
    if (isAnimatingRef.current || queueRef.current.length === 0) {
      return;
    }

    const nextStep = queueRef.current.shift()!;
    isAnimatingRef.current = true;

    // Update label immediately
    setDisplayStep(nextStep);

    // Small delay so text changes before bar moves
    setTimeout(() => {
      setProgress(getProgressForStep(nextStep));
    }, 100);

    // Wait for animation to complete before processing next step
    animationTimeoutRef.current = setTimeout(() => {
      isAnimatingRef.current = false;

      // Trigger onComplete callback if we reached the final step
      const finalStep = steps[steps.length - 1];
      if (nextStep === finalStep) {
        onComplete?.();
      }

      // Process next item in queue (if any)
      if (queueRef.current.length > 0) {
        processNextStep();
      }
    }, animationDuration + 100); // Add 100ms buffer to ensure animation completes
  };

  // Enqueue step updates - watch currentStep only
  useEffect(() => {
    // Get current display step from state ref
    setDisplayStep(prev => {
      if (currentStep > prev) {
        const nextSteps = steps.filter(s => s > prev && s <= currentStep);

        // Only add steps that aren't already in the queue
        const uniqueSteps = nextSteps.filter(s => !queueRef.current.includes(s));

        if (uniqueSteps.length > 0) {
          queueRef.current.push(...uniqueSteps);

          // Start processing if not already animating
          if (!isAnimatingRef.current) {
            // Use setTimeout to avoid state update during render
            setTimeout(() => processNextStep(), 0);
          }
        }
      }
      return prev;
    });
  }, [currentStep]); // Only watch currentStep

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (animationTimeoutRef.current) {
        clearTimeout(animationTimeoutRef.current);
      }
    };
  }, []);

  const label = labelMap[displayStep as keyof typeof labelMap];

  return (
    <div className={cn("w-full flex flex-col gap-2", className)}>
      <Text variant="tiny" className={cn("text-sm text-ui_blue text-center", messageClassName)}>
        {message}
      </Text>

      <span className="flex w-full items-center gap-[1px]">
        <div className="h-3 border-ui_grey/50 rounded-sm border-2 flex-grow">
          <div
            className="h-full bg-gradient-to-br rounded-sm from-ui_blue to-ui_blue_light transition-all ease-out"
            style={{
              width: `${progress}%`,
              transitionDuration: `${animationDuration}ms`,
            }}
          />
        </div>
        <Text variant="tiny" className="text-sm text-ui_blue -translate-y-[1px]">
          {Math.round(progress)}%
        </Text>
      </span>
    </div>
  );
};
